import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';

export default function RowActions({
  isEditing,
  saving,
  onEdit,
  onDelete,
  onSave,
  onCancel,
}) {
  if (isEditing) {
    return (
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <Tooltip title="Save">
          <IconButton
            size="small"
            color="success"
            onClick={onSave}
            disabled={saving}
          >
            <SaveIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Cancel">
          <IconButton
            size="small"
            color="error"
            onClick={onCancel}
            disabled={saving}
          >
            <CancelIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <Tooltip title="Edit">
        <IconButton size="small" onClick={onEdit}>
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton size="small" color="error" onClick={onDelete}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

